export const channelList = [
  { name: '站内信', value: 'IM' },
  { name: '邮箱', value: 'EMAIL' },
  { name: '华为云', value: 'HUAWEI_SMS' },
  { name: '腾讯云', value: 'TENCENT_SMS' },
  { name: '微信公众号', value: 'WX_MP' },
  { name: '极光', value: 'JIGUANG' },
  { name: '亿美软通', value: 'YIMEI' },
]

export const YIMEI_verifyMap = {
  0: '待审核',
  1: '通过',
  2: '审核失败',
  '-1': '模板不存在',
}
export const YIMEI_verifyCssMap = {
  0: 'normal',
  1: 'pass',
  2: 'fail',
  '-1': 'error',
}

export const ChannelName = {}
channelList.forEach((item) => {
  ChannelName[item.value] = item.name
})

export const isSms = ['HUAWEI_SMS', 'TENCENT_SMS', 'JIGUANG', 'YIMEI']

export default {
  channelList,
  ChannelName,
  YIMEI_verifyMap,
  YIMEI_verifyCssMap,
  isSms
}